<div class="error-page-container">
  <div class="error-page-content">
    <i class="an an-lock error-icon"></i>
    <h1 class="error-code">403</h1>
    <h2 class="error-title">Sem permissão de acesso</h2>
    <p class="error-description">
      Você não tem permissão para acessar esta página.
      Caso precise de acesso, entre em contato com o administrador ou consulte a documentação.
    </p>
    <div class="error-actions">
      <po-button
        p-label="Acessar documentação"
        p-icon="po-icon po-icon-info"
        (p-click)="openDocumentation()">
      </po-button>
      <po-button
        p-label="Ir para o início"
        p-icon="po-icon po-icon-home"
        (p-click)="goHome()">
      </po-button>
    </div>
  </div>
</div>
